import React from 'react';
import { Skeleton } from 'antd';
import { ObjectGridSkeleton } from '../ObjectGridSkeleton';
import { CLASS_NAMES } from '../../constants';
// The layout classes this skeleton draws with (home-wrapper, home-header-wrap…)
// live in the page's stylesheet. Imported here too because the skeleton is the
// route's Suspense fallback: it renders before HomePage's chunk — and its CSS —
// has loaded.
import '../../pages/HomePage.css';

/** Height and radius of the header's real controls (antd controlHeight 40, radius md). */
const SKELETON_CONTROL_STYLE: React.CSSProperties = { height: 40, borderRadius: 12 };

export const HomeHeaderSkeleton: React.FC = () => (
  <>
    <div className="home-header-wrap">
      <div className="home-header-left home-header-left--skeleton">
        <Skeleton.Input active size="large" style={{ width: 220, height: 28, borderRadius: 8 }} />
        <Skeleton.Input active size="small" style={{ width: 300, height: 16, borderRadius: 6 }} />
      </div>
      {/* The real header's own classes, so the skeleton inherits its widths and
          breakpoints (filter 150 / search 320→220 / create 141, stacked full
          width at ≤640px) instead of fixed sizes that overflow on mobile. */}
      <div className="home-header-actions">
        <div className="home-header-actions__filter">
          <Skeleton.Input active block style={SKELETON_CONTROL_STYLE} />
        </div>
        <div className="home-header-actions__search">
          <Skeleton.Input active block style={SKELETON_CONTROL_STYLE} />
        </div>
        <div className="home-header-actions__create home-header-actions__create--skeleton">
          <Skeleton.Button active block style={SKELETON_CONTROL_STYLE} />
        </div>
      </div>
    </div>
    <div className="home-divider" />
  </>
);

export const HomePageSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`${CLASS_NAMES.WRAPPER} ${className || ''}`}>
    <div className="home-banner-skeleton" aria-hidden />

    <div className={CLASS_NAMES.BODY}>
      <div className={CLASS_NAMES.CONTENT_CARD}>
        <HomeHeaderSkeleton />
        <ObjectGridSkeleton />
      </div>
    </div>
  </div>
);
